import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"label":_vm.$t('Resource Types'),"items":_vm.items,"loading":_vm.loading,"multiple":"","outlined":"","hide-details":"auto"},model:{value:(_vm.resourceTypes),callback:function ($$v) {_vm.resourceTypes=$$v},expression:"resourceTypes"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }